<template>
    <div class="page">
        <IndexHeader />

        <main class="page-main">
            <div class="card">
                <div class="card-header">
                    <div class="title-group">
                        <h1 class="title">代理用户</h1>
                        <p class="subtitle">以下为官方认证授权商用户，联系他们可获取微信/支付宝等更多支付方式</p>
                    </div>
                    <span class="header-chip">
                        <user-filled />
                        共计{{ total }} 位代理
                    </span>
                </div>

                <div class="agent-grid" v-if="agentList.length > 0">
                    <div class="agent-card" v-for="agent in agentList" :key="agent.uid">
                        <div class="agent-avatar" :style="agent.avatar ? {} : { background: getAvatarGradient(agent) }">
                            <img v-if="agent.avatar" :src="agent.avatar" class="avatar-img" />
                            <span v-else class="avatar-text">{{ getAvatarText(agent) }}</span>
                        </div>
                        <div class="agent-info">
                            <div class="agent-name-row">
                                <h3 class="agent-name">{{ agent.username || '未设置昵称' }}</h3>
                                <span class="agent-grade" :class="'grade-' + agent.grade">{{ agent.grade_name }}</span>
                            </div>
                            <div class="agent-detail" v-if="agent.contact">
                                <span class="detail-label">联系方式</span>
                                <span class="detail-value">{{ agent.contact }}</span>
                            </div>
                            <div class="agent-detail no-contact" v-else>
                                <info-circle-outlined />
                                <span class="no-contact-text">该代理暂未预留联系方式，请过几天再看</span>
                            </div>
                            <div class="agent-actions" v-if="agent.tenant_key && agent.shop_status === 1">
                                <a-button size="small" type="primary" ghost @click="openShop(agent.tenant_key)">
                                    打开小店
                                </a-button>
                            </div>
                        </div>
                    </div>
                </div>

                <a-empty v-else description="暂无代理用户信息" />

                <div class="pagination-wrapper" v-if="total > pageSize">
                    <a-pagination :current="page" :page-size="pageSize" :total="total" @change="handlePageChange" />
                </div>

                <div class="notice-box">
                    <info-circle-outlined />
                    <p>易售客服仅支持 <strong>USDT</strong> 付款，如需微信、支付宝等支付方式，请联系上方代理用户。</p>
                    <p>如需举报违规代理用户，请联系飞机官方客服。</p>
                </div>

                <div class="agent-tip-box">
                    <gift-outlined />
                    <div class="tip-content">
                        <p class="tip-title">开通代理</p>
                        <p class="tip-text">如果您要开通代理可以联系官方客服预存或付费开通，也可以联系其他代理用户付费开通。</p>
                        <p class="tip-highlight">推荐用户到客服处预存开通代理/升级代理可得奖励：预存金额的 <strong>10%</strong></p>
                    </div>
                </div>
            </div>
        </main>

        <IndexFooter />
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import axios from 'axios';
import { message } from 'ant-design-vue'
import IndexHeader from '@/components/IndexHeader.vue'
import IndexFooter from '@/components/IndexFooter.vue'

const baseURL = process.env.VUE_APP_API_BASE_URL;

export default defineComponent({
    name: 'AgentListView',
    components: {
        IndexHeader,
        IndexFooter
    },
    data() {
        return {
            agentList: [],
            loading: false,
            page: 1,
            pageSize: 10,
            total: 0
        }
    },
    methods: {
        async getAgentList() {
            this.loading = true;
            try {
                const res = await axios.get(`${baseURL}/xiaochu/getAgentList?includes_id=20&page=${this.page}&pageSize=${this.pageSize}`, {
                    timeout: 10000
                });
                if (res.data.code === 0) {
                    this.agentList = res.data.data || [];
                    this.total = res.data.total || 0;
                } else {
                    message.error(res.data.msg || '获取代理列表失败');
                }
            } catch (error) {
                console.error('获取代理列表失败:', error);
                message.error('获取代理列表失败，请稍后重试');
            } finally {
                this.loading = false;
            }
        },

        handlePageChange(page) {
            this.page = page;
            this.getAgentList();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },

        getAvatarGradient(agent) {
            const gradients = [
                'linear-gradient(135deg, #667eea, #764ba2)',
                'linear-gradient(135deg, #f093fb, #f5576c)',
                'linear-gradient(135deg, #4facfe, #00f2fe)',
                'linear-gradient(135deg, #43e97b, #38f9d7)',
                'linear-gradient(135deg, #fa709a, #fee140)',
                'linear-gradient(135deg, #a8edea, #fed6e3)',
                'linear-gradient(135deg, #ff9a9e, #fecfef)',
                'linear-gradient(135deg, #ffecd2, #fcb69f)',
                'linear-gradient(135deg, #a1c4fd, #c2e9fb)',
                'linear-gradient(135deg, #d4fc79, #96e6a1)'
            ];
            const str = agent.username || agent.grade_name || '';
            let hash = 0;
            for (let i = 0; i < str.length; i++) {
                hash = str.charCodeAt(i) + ((hash << 5) - hash);
            }
            return gradients[Math.abs(hash) % gradients.length];
        },

        getAvatarText(agent) {
            if (agent.username) {
                return agent.username.slice(0, 2).toUpperCase();
            }
            return '未';
        },

        openShop(tenantKey) {
            this.$router.push({ path: '/shop', query: { tenant_key: tenantKey } });
        }
    },
    mounted() {
        this.getAgentList();
    }
})
</script>

<style scoped lang="scss">
.page {
    min-height: 100vh;
    background: linear-gradient(180deg, #f8fafc 0%, #eef2ff 60%, #f8fafc 100%);
    display: flex;
    flex-direction: column;
}

.page-main {
    max-width: 1200px;
    margin: 0 auto;
    padding: 12vh 1.5rem 4rem;
    display: flex;
    flex-direction: column;
    gap: 3rem;
    height: 90vh;
    overflow-y: auto;
    width: 100%;
    box-sizing: border-box;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
        width: 0;
        height: 0;
        display: none;
    }
}

.card {
    background: #ffffff;
    border-radius: 1.4rem;
    border: 1px solid rgba(226, 232, 240, 0.9);
    box-shadow: 0 22px 45px -30px rgba(37, 99, 235, 0.25);
    padding: 2.4rem 2.6rem;

    @media (max-width: 640px) {
        padding: 1.5rem 1.2rem;
    }
}

.card-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1.5rem;
    margin-bottom: 2rem;
    flex-wrap: wrap;

    @media (max-width: 640px) {
        flex-direction: column;
        gap: 1rem;
    }
}

.title-group {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
}

.title {
    font-size: 1.8rem;
    font-weight: 700;
    color: #0f172a;
    margin: 0;

    @media (max-width: 640px) {
        font-size: 1.5rem;
    }
}

.subtitle {
    font-size: 0.95rem;
    color: #64748b;
    margin: 0;

    @media (max-width: 640px) {
        font-size: 0.85rem;
    }
}

.header-chip {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.5rem 1rem;
    border-radius: 9999px;
    font-size: 0.85rem;
    font-weight: 600;
    background: linear-gradient(135deg, rgba(37, 99, 235, 0.15), rgba(37, 99, 235, 0.1));
    color: #1d4ed8;
    border: 1px solid rgba(37, 99, 235, 0.25);
    white-space: nowrap;
    box-shadow: 0 8px 18px -16px rgba(37, 99, 235, 0.5);

    .anticon {
        font-size: 1rem;
    }
}

.agent-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 1.2rem;
    margin-bottom: 2rem;
}

.agent-card {
    display: flex;
    gap: 1rem;
    padding: 1.25rem;
    border-radius: 1.1rem;
    border: 1px solid rgba(226, 232, 240, 0.9);
    background: linear-gradient(135deg, #f8fafc, #ffffff);
    box-shadow: 0 8px 16px -12px rgba(15, 23, 42, 0.15);
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:hover {
        transform: translateY(-3px);
        box-shadow: 0 14px 24px -16px rgba(37, 99, 235, 0.3);
        border-color: rgba(37, 99, 235, 0.3);
    }

    @media (max-width: 640px) {
        padding: 1rem;
    }
}

.agent-avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    min-width: 56px;
    border-radius: 1rem;
    box-shadow: 0 8px 16px -8px rgba(0, 0, 0, 0.2);

    @media (max-width: 640px) {
        width: 48px;
        height: 48px;
        min-width: 48px;
    }
}

.avatar-text {
    font-size: 1.2rem;
    font-weight: 700;
    color: #ffffff;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    letter-spacing: 0.05em;

    @media (max-width: 640px) {
        font-size: 1rem;
    }
}

.avatar-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: inherit;
}

.agent-info {
    flex: 1;
    min-width: 0;
}

.agent-name-row {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    flex-wrap: wrap;
    margin-bottom: 0.5rem;
}

.agent-name {
    font-size: 1.1rem;
    font-weight: 600;
    color: #0f172a;
    margin: 0;

    @media (max-width: 640px) {
        font-size: 1rem;
    }
}

.agent-grade {
    display: inline-flex;
    padding: 0.2rem 0.6rem;
    border-radius: 9999px;
    font-size: 0.7rem;
    font-weight: 600;

    &.grade-1 {
        background: rgba(59, 130, 246, 0.12);
        color: #2563eb;
        border: 1px solid rgba(59, 130, 246, 0.2);
    }

    &.grade-2 {
        background: rgba(168, 85, 247, 0.12);
        color: #9333ea;
        border: 1px solid rgba(168, 85, 247, 0.2);
    }

    &.grade-3 {
        background: rgba(249, 115, 22, 0.12);
        color: #ea580c;
        border: 1px solid rgba(249, 115, 22, 0.2);
    }

    &.grade-4 {
        background: rgba(6, 182, 212, 0.12);
        color: #0891b2;
        border: 1px solid rgba(6, 182, 212, 0.2);
    }

    &.grade-5 {
        background: rgba(239, 68, 68, 0.12);
        color: #dc2626;
        border: 1px solid rgba(239, 68, 68, 0.2);
    }

    &.grade-6 {
        background: linear-gradient(135deg, rgba(251, 191, 36, 0.2), rgba(245, 158, 11, 0.2));
        color: #d97706;
        border: 1px solid rgba(251, 191, 36, 0.3);
    }
}

.agent-detail {
    display: flex;
    flex-direction: column;
    gap: 0.15rem;
    margin-bottom: 0.3rem;

    &:last-child {
        margin-bottom: 0;
    }

    &.no-contact {
        flex-direction: row;
        align-items: flex-start;
        gap: 0.4rem;
        padding: 0.5rem 0.7rem;
        background: rgba(148, 163, 184, 0.1);
        border-radius: 0.6rem;
        margin-top: 0.3rem;

        .anticon {
            color: #94a3b8;
            font-size: 0.9rem;
            margin-top: 0.05rem;
        }
    }
}

.agent-actions {
    margin-top: 0.6rem;
}

.no-contact-text {
    font-size: 0.8rem;
    color: #94a3b8;
    line-height: 1.4;
}

.detail-label {
    font-size: 0.75rem;
    color: #94a3b8;
    font-weight: 500;
}

.detail-value {
    font-size: 0.9rem;
    color: #475569;
    word-break: break-all;

    @media (max-width: 640px) {
        font-size: 0.85rem;
    }
}

.pagination-wrapper {
    display: flex;
    justify-content: center;
    margin: 2rem 0 1.5rem;

    :deep(.ant-pagination) {
        background: #f8fafc;
        padding: 0.75rem 1rem;
        border-radius: 1rem;
        border: 1px solid rgba(226, 232, 240, 0.9);

        .ant-pagination-prev,
        .ant-pagination-next {
            border-radius: 0.5rem;
        }

        .ant-pagination-item {
            border-radius: 0.5rem;
        }

        .ant-pagination-item-active {
            background: linear-gradient(135deg, #2563eb, #3b82f6);
            border-color: transparent;

            a {
                color: #fff;
            }
        }
    }
}

.notice-box {
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    padding: 1.25rem;
    border-radius: 1rem;
    background: linear-gradient(135deg, #fefce8, #fef9c3);
    border: 1px solid rgba(234, 179, 8, 0.3);

    .anticon {
        font-size: 1.2rem;
        color: #ca8a04;
        margin-top: 0.1rem;
    }

    p {
        margin: 0;
        font-size: 0.9rem;
        color: #713f12;
        line-height: 1.6;

        strong {
            color: #a16207;
            font-weight: 600;
        }
    }

    @media (max-width: 640px) {
        padding: 1rem;
        gap: 0.5rem;

        .anticon {
            font-size: 1rem;
        }

        p {
            font-size: 0.85rem;
        }
    }
}

.agent-tip-box {
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    padding: 1.25rem;
    border-radius: 1rem;
    background: linear-gradient(135deg, #eff6ff, #dbeafe);
    border: 1px solid rgba(37, 99, 235, 0.3);
    margin-top: 1.5rem;

    .anticon {
        font-size: 1.4rem;
        color: #2563eb;
        margin-top: 0.1rem;
    }

    @media (max-width: 640px) {
        padding: 1rem;
        gap: 0.5rem;

        .anticon {
            font-size: 1.2rem;
        }
    }
}

.tip-content {
    flex: 1;
}

.tip-title {
    font-size: 1rem;
    font-weight: 600;
    color: #1d4ed8;
    margin: 0 0 0.4rem;
}

.tip-text {
    font-size: 0.9rem;
    color: #1e40af;
    margin: 0 0 0.5rem;
    line-height: 1.5;
}

.tip-highlight {
    font-size: 0.9rem;
    color: #1e40af;
    margin: 0;
    line-height: 1.5;

    strong {
        color: #1d4ed8;
        font-weight: 700;
        font-size: 1.1rem;
    }

    @media (max-width: 640px) {
        font-size: 0.85rem;

        strong {
            font-size: 1rem;
        }
    }
}
</style>
